import { ClarityType } from '../clarityValue.esm.js';

function responseErrorCV(value) {
  return {
    type: ClarityType.ResponseErr,
    value: value
  };
}

function responseOkCV(value) {
  return {
    type: ClarityType.ResponseOk,
    value: value
  };
}

export { responseErrorCV, responseOkCV };
//# sourceMappingURL=responseCV.esm.js.map
